﻿$.fn.dxCtrlGridPlaniti = function custom_dxCtrlGridPlaniti(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridplaniti dx-ctrl");
        this.createInstance(new cdxCtrlGridPlaniti(this, option));
    }
    return this;
}

window.cdxCtrlGridPlaniti = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "gridplaniti"

    var _disableUpdateFunction = false
    option.bddCtrl.mAddFunctionOnModifiedItemData(["planiti"], container,
        function (action, itemData) {
            if (_disableUpdateFunction) {
                _disableUpdateFunction = false
                return
            }
            if (typeof itemData != 'undefined') {
                dxGrid.mUpdateData(action, option.bddCtrl.table.mGetItemFromNom("planiti").id_table, itemData.id_planiti)
            } else {
                dxGrid.mUpdateData()
            }
        })

    function mConstruit() {
        container.empty();

        container.css("height", "100%")

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid({
            bddCtrl: option.bddCtrl,
            noDataText: "Aucun évènement",
            typeData: "planiti",
            context_grid: option.context_grid,
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            allowDeleteInToolbar: false,
            lstTypeGrille: ["Détails"],
            fields: mGetLstField(),
            allowCarto: false,
            allowFilter: false,
            allowLucene: true,
            allowCheck: false
        }).dxCtrlVirtualGrid("instance")
    }

    function mGetLstField() {
        var lst = []
        lst = lst.concat([{
            name: "dcr",
            dataField: "dcr",
            caption: "Date création",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            groupIndex: 0,
            sortOrder: "desc",
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Création: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: true,
            visible: false
        }])

        lst = lst.concat([{
            name: "dmo",
            dataField: "dmo",
            caption: "Date modification",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dmo.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Modification: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "dmo_tri"
        }, {
            name: "dmo_tri",
            dataField: "dmo_tri",
            allowGrid: true,
            visible: false
        }])

        lst = lst.concat([{
            name: "id_utilisateur",
            dataField: "id_utilisateur",
            caption: "Utilisateur",
            icon: "fas fa-user",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            calculateGroupValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            groupCellTemplate: function (columnElement, options) {
                var txt = options.data.key
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-user dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + txt + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.id_utilisateur
            },
            calculateSortValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            filterProperty: {
                lookup: option.bddCtrl.getObjet("utilisateur").objetMetier.mGetLookUpForFilterBuilder(),
                filterOperations: ["parmi", "notparmi"]
            }
        }, {
            name: "nom",
            dataField: "nom",
            caption: "nom",
            allowFilter: false,
            allowGrid: true,
            allowGrouping: false,
            dataType: "string"
        }])
        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []

        items.push({
            location: 'before',
            template: function (itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-share-nodes",
                    icon2: "fas fa-certificate",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    txtTooltip: "Nouvel évènement",
                    onClick: function (e) {
                        option.bddCtrl.mAjaxCall({ command: "createnewplaniti" }, function (data) {
                            var dataPlaniti = option.bddCtrl.getObjet("planiti", data.id_planiti).data
                            option.bddCtrl.getObjet(dataPlaniti).mShowPopup()
                        })
                    }
                }).dxCtrlButton("instance")
            }
        })

        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {
        var items = []

        items.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            options: {
                icon: "fas fa-trash-alt",
                elementAttr: { class: "dx-button-grille-ligne" },
                focusStateEnabled: false,
                text: "Supprimer",
                hint: "Supprimer",
                onClick(e) {
                    e.event.stopPropagation();
                    dxGrid.mRemoveRow(dataGrid)
                    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                    _disableUpdateFunction = true
                    obj.mDelData(function () { })
                }
            },
        })

        toolbar.option("items", items)
    }

    this.element = function () { return container; }

    mConstruit();
}